import { LoadScript } from "../../../../shared/ScriptHelper";
import { isNullOrEmpty } from "../../../../shared/StringHelper";
import { useEffectAsync } from "../../../../shared/useEffectAsync";
import { useGraphQL } from "../../../../shared/useGraphQL";

declare global {
    interface Window {
        friendbuyAPI: any;
    }
}

interface FriendbuyProps {
    merchantId: string,
    email: string,
    authString: string,
    signature: string
}

export default function Friendbuy(props: FriendbuyProps) {
    const graphQLClient = useGraphQL();

    useEffectAsync(async () => {
        if (isNullOrEmpty(props?.merchantId))
            return;

        const friendbuyAPI = window.friendbuyAPI || [];

        friendbuyAPI.merchantId = props?.merchantId;
        friendbuyAPI.push(["merchant", props?.merchantId]);

        const scriptUrls: string[] = ["https://static.fbot.me/friendbuy.js", `https://campaign.fbot.me/${props?.merchantId}/campaigns.js`];
        scriptUrls.forEach((src) => LoadScript(src, [{ name: "async", value: "true" }]));

        friendbuyAPI.push(["auth", props?.authString, props?.signature]);

        window.friendbuyAPI = friendbuyAPI;
    }, [graphQLClient]);

    return null;
};